export default [
  { text: "Descubrimiento", key: "DISCOVERY", value: "DISCOVERY" },
  { text: "Aceleración", key: "ACCELERATING", value: "ACCELERATING" },
  { text: "Validación", key: "VALIDATING", value: "VALIDATING" },
  { text: "Lanzamiento", key: "LAUNCHING", value: "LAUNCHING" },
];
